import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { ContratosForm } from "../modais"
import Layout from "../Layout"
class ContratosEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <ContratosForm isEditing={true} callBackContratos={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratosEditForm)



// WEBPACK FOOTER //
// ./src/views/contratos/ContratosEditForm.js